module.exports = __webpack_public_path__ + "media/images/emblems/Mergoscia-coat_of_arms-49f6e7af388ae5ee4e78322bb19332ab.svg";